import {createStyles, Theme} from "@material-ui/core";
import {styleColors} from "src/main.style";

export const DayVisitChangeStyle = (theme: Theme) => createStyles({
  caption : {
    fontSize: '14px',
    fontWeight: 400,
  },
  parent : {
    fontSize: '28px',
    fontWeight: 700,
    lineHeight: 1.2,
    marginBottom: '16px',
  },
  changeTo : {
    fontSize: '14px',
    fontWeight: 400,
    margin: '12px 0',
  },
  card : {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: styleColors.white,
    border: `1px solid ${styleColors.greyLight3}`,
    borderRadius: '12px',
    padding: '16px 12px',
  },
  cardOld : {
    opacity: 0.5,
    '& $time': {
      textDecoration: 'line-through',
    },
  },
  day : {
    fontSize: '13px',
    fontWeight: 500,
    letterSpacing: '1px',
    textTransform: 'uppercase',
    textAlign: 'center',
    marginBottom: '4px',
  },
  // equal columns on both sides keep the dash in the middle of the card
  times : {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) auto minmax(0, 1fr)',
    alignItems: 'start',
  },
  startColumn : {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    textAlign: 'right',
    minWidth: 0,
  },
  endColumn : {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'left',
    minWidth: 0,
  },
  // wraps (e.g. before AM/PM) instead of overflowing the card in narrow dialogs
  time : {
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: 1.3,
  },
  dash : {
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: 1.3,
    margin: '0 8px',
  },
  place : {
    display: 'flex',
    alignItems: 'flex-start',
    fontSize: '14px',
    marginTop: '4px',
    overflowWrap: 'break-word',
    maxWidth: '100%',
  },
  placeIcon : {
    fontSize: '18px',
    marginRight: '4px',
    flexShrink: 0,
    color: styleColors.deepPurple,
  },
});



// WEBPACK FOOTER //
// ./src/components/calendar2/DayVisitChange.style.ts